import { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import { useAuth } from './useAuth';

export function useUsers() {
  const { user } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchUsers = useCallback(async () => {
    if (!user || user.role !== 'Admin') {
      setLoading(false);
      return;
    }
    
    setLoading(true);
    try {
      const response = await api.get('admin/users/');
      setUsers(response.data);
      setError(null);
    } catch (err) {
      console.error("Failed to fetch users:", err);
      setError(err.response?.data?.detail || "Failed to load users");
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  const approveUser = async (userId) => {
    try {
      await api.put(`admin/users/${userId}/approve/`, {});
      await fetchUsers();
      return { success: true };
    } catch (err) {
      return { success: false, error: err.response?.data?.detail || "Failed to approve user" };
    }
  };

  return {
    users,
    loading,
    error,
    refreshUsers: fetchUsers,
    approveUser
  };
}
